import React from 'react';
import { Button } from '../components/ui/button';
import { Phone, Building2, Factory, Waves, Zap, Construction, Wheat } from 'lucide-react';
import './Clientes.css';

// Toggle a `true` cuando la lista de logos est\u00e9 actualizada para volver a mostrar la grilla.
const SHOW_LOGOS = false;

const Clientes = () => {
  const whatsappNumber = '5493413047536';
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=\u00a1Hola!%20Quiero%20conocer%20m\u00e1s%20sobre%20sus%20servicios`;

  const sectores = [
    {
      icon: <Waves size={28} />,
      nombre: 'Agua y saneamiento',
      descripcion: 'Empresas de distribución de agua potable, tratamiento de efluentes y servicios sanitarios.'
    },
    {
      icon: <Factory size={28} />,
      nombre: 'Industria química y petroquímica',
      descripcion: 'Plantas de producción, refinerías y empresas del sector energético.'
    },
    {
      icon: <Wheat size={28} />,
      nombre: 'Agroindustria',
      descripcion: 'Plantas de procesamiento de granos, aceites vegetales y producción de alimento balanceado.'
    },
    {
      icon: <Zap size={28} />,
      nombre: 'Energía',
      descripcion: 'Centrales térmicas, hidroeléctricas y proyectos de infraestructura energética.'
    },
    {
      icon: <Building2 size={28} />,
      nombre: 'Construcción',
      descripcion: 'Desarrollos inmobiliarios, edificios comerciales e institucionales.'
    },
    {
      icon: <Construction size={28} />,
      nombre: 'Minería',
      descripcion: 'Proyectos mineros y de extracción de recursos naturales.'
    }
  ];

  const clientes = [
    { nombre: 'ACA', logo: '/assets/logos/clientes/ACA-LOGO.webp' },
    { nombre: 'ACHA', logo: '/assets/logos/clientes/ACHA-LOGO.webp' },
    { nombre: 'ACINDAR', logo: '/assets/logos/clientes/ACINDAR-LOGO.webp' },
    { nombre: 'ADALMI', logo: '/assets/logos/clientes/ADALMI-LOGO.webp' },
    { nombre: 'ADM', logo: '/assets/logos/clientes/ADM-LOGO.webp' },
    { nombre: 'AES', logo: '/assets/logos/clientes/AES-LOGO.webp' },
    { nombre: 'AFA', logo: '/assets/logos/clientes/AFA-LOGO.webp' },
    { nombre: 'AGD', logo: '/assets/logos/clientes/AGD-LOGO.webp' },
    { nombre: 'AGROSERVICIOS HUMBOLDT', logo: '/assets/logos/clientes/AGROSERVICIOS-HUMBOLDT-LOGO.webp' },
    { nombre: 'AGUAS SANTAFESINAS', logo: '/assets/logos/clientes/AGUAS-SANTAFESINAS-LOGO.webp' },
    { nombre: 'AIR LIQUIDE', logo: '/assets/logos/clientes/AIR-LIQUIDE-LOGO.webp' },
    { nombre: 'ALBANESI', logo: '/assets/logos/clientes/ALBANESI-LOGO.webp' },
    { nombre: 'ALGODONERA AVELLANEDA', logo: '/assets/logos/clientes/ALGODONERA-AVELLANEDA-LOGO.webp' },
    { nombre: 'AMBEV', logo: '/assets/logos/clientes/AMBEV-LOGO.webp' },
    { nombre: 'AR ZINC', logo: '/assets/logos/clientes/AR-ZINC-LOGO.webp' },
    { nombre: 'ARAUCO', logo: '/assets/logos/clientes/ARAUCO-LOGO.webp' },
    { nombre: 'ASTRAZENECA', logo: '/assets/logos/clientes/ASTRAZENECA-LOGO.webp' },
    { nombre: 'AVIGAN', logo: '/assets/logos/clientes/AVIGAN-LOGO.webp' },
    { nombre: 'BANCO NACION', logo: '/assets/logos/clientes/BANCO-NACION-LOGO.webp' },
    { nombre: 'BIO4', logo: '/assets/logos/clientes/BIO4-LOGO.webp' },
    { nombre: 'BOLSA COMERCIO', logo: '/assets/logos/clientes/BOLSA-COMERCIO-LOGO.webp' },
    { nombre: 'BOORTMALT', logo: '/assets/logos/clientes/BOORTMALT-LOGO.webp' },
    { nombre: 'BOSCARINO CONSTRUCCIONES', logo: '/assets/logos/clientes/BOSCARINO-CONSTRUCCIONES-LOGO.webp' },
    { nombre: 'BRF MARFRIG', logo: '/assets/logos/clientes/BRF-MARFRIG-LOGO.webp' },
    { nombre: 'BUNGE', logo: '/assets/logos/clientes/BUNGE-LOGO.webp' },
    { nombre: 'BUYANOR', logo: '/assets/logos/clientes/BUYANOR-LOGO.webp' },
    { nombre: 'BUYATTI', logo: '/assets/logos/clientes/BUYATTI-LOGO.webp' },
    { nombre: 'CARGILL', logo: '/assets/logos/clientes/CARGILL-LOGO.webp' },
    { nombre: 'CARREFOUR', logo: '/assets/logos/clientes/CARREFOUR-LOGO.webp' },
    { nombre: 'CARTONERA PUERTO', logo: '/assets/logos/clientes/CARTONERA-PUERTO-LOGO.webp' },
    { nombre: 'CCU', logo: '/assets/logos/clientes/CCU-LOGO.webp' },
    { nombre: 'CENTRAL VUELTA OBLIGADO', logo: '/assets/logos/clientes/CENTRAL-VUELTA-OBLIGADO-LOGO.webp' },
    { nombre: 'CENTRALES COSTA ATLANTICA', logo: '/assets/logos/clientes/CENTRALES-COSTA-ATLANTICA-LOGO.webp' },
    { nombre: 'CERAMICA ALBERDI', logo: '/assets/logos/clientes/CERAMICA-ALBERDI-LOGO.webp' },
    { nombre: 'COCYAR', logo: '/assets/logos/clientes/COCYAR-LOGO.webp' },
    { nombre: 'COEMYC', logo: '/assets/logos/clientes/COEMYC-LOGO.webp' },
    { nombre: 'COFCO', logo: '/assets/logos/clientes/COFCO-LOGO.webp' },
    { nombre: 'COMACSA', logo: '/assets/logos/clientes/COMACSA-LOGO.webp' },
    { nombre: 'CONSTRUCCIONES CIVILES INDUSTRIALES', logo: '/assets/logos/clientes/CONSTRUCCIONES-CIVILES-INSDUSTRIALES-LOGO.webp' },
    { nombre: 'CORTEVA', logo: '/assets/logos/clientes/CORTEVA-LOGO.webp' },
    { nombre: 'CPM', logo: '/assets/logos/clientes/CPM-LOGO.webp' },
    { nombre: 'CSB', logo: '/assets/logos/clientes/CSB-LOGO.webp' },
    { nombre: 'DANA', logo: '/assets/logos/clientes/DANA-LOGO.webp' },
    { nombre: 'DETEXA', logo: '/assets/logos/clientes/DETEXA-LOGO.webp' },
    { nombre: 'DOW QUIMICA', logo: '/assets/logos/clientes/DOW-QUIMICA-LOGO.webp' },
    { nombre: 'EDECA', logo: '/assets/logos/clientes/EDECA-LOGO.webp' },
    { nombre: 'ENTRE RIOS CRUSHING', logo: '/assets/logos/clientes/ENTRE-RIOS-CRUSHING-LOGO.webp' },
    { nombre: 'EXPLORA', logo: '/assets/logos/clientes/EXPLORA-LOGO.webp' },
    { nombre: 'FEPASA', logo: '/assets/logos/clientes/FEPASA-LOGO.webp' },
    { nombre: 'FIPLASTO', logo: '/assets/logos/clientes/FIPLASTO-LOGO.webp' },
    { nombre: 'FRIAR', logo: '/assets/logos/clientes/FRIAR-LOGO.webp' },
    { nombre: 'GENERAL MOTORS', logo: '/assets/logos/clientes/GENERAL-MOTORS-LOGO.webp' },
    { nombre: 'GENTE DE LA PAMPA', logo: '/assets/logos/clientes/GENTE-DE-LA-PAMPA-LOGO.webp' },
    { nombre: 'GERDAU', logo: '/assets/logos/clientes/GERDAU-LOGO.webp' },
    { nombre: 'GIER', logo: '/assets/logos/clientes/GIER-LOGO.webp' },
    { nombre: 'GLENCORE', logo: '/assets/logos/clientes/GLENCORE-LOGO.webp' },
    { nombre: 'HIDRAULICA ENTRE RIOS', logo: '/assets/logos/clientes/HIDRAULICA-ENTRE-RIOS-LOGO.svg' },
    { nombre: 'HIDROCONSTRUCCIONES', logo: '/assets/logos/clientes/HIDROCONSTRUCCIONES-LOGO.webp' },
    { nombre: 'IDM INGENIERIA', logo: '/assets/logos/clientes/IDM-INGENIERIA-CONSTRUCCION-LOGO.webp' },
    { nombre: 'INAGRO', logo: '/assets/logos/clientes/INAGRO-LOGO.webp' },
    { nombre: 'INNOVA', logo: '/assets/logos/clientes/INNOVA-LOGO.webp' },
    { nombre: 'JSB', logo: '/assets/logos/clientes/JSB-LOGO.webp' },
    { nombre: 'KECLON', logo: '/assets/logos/clientes/KECLON-LOGO.webp' },
    { nombre: 'LA NUEVA MANERA VIRGILIO', logo: '/assets/logos/clientes/LA-NUEVA-MANERA-VIRGILIO-LOGO.webp' },
    { nombre: 'LA SIBILA', logo: '/assets/logos/clientes/LA-SIBILA-LOGO.webp' },
    { nombre: 'LA VIRGINIA', logo: '/assets/logos/clientes/LA-VIRGINIA-LOGO.webp' },
    { nombre: 'LAS CAMELIAS', logo: '/assets/logos/clientes/LAS-CAMELIAS-LOGO.webp' },
    { nombre: 'LDC', logo: '/assets/logos/clientes/LDC-LOGO.webp' },
    { nombre: 'MASA', logo: '/assets/logos/clientes/MASA-LOGO.webp' },
    { nombre: 'MASTRODICASA CONSTRUCCIONES', logo: '/assets/logos/clientes/MASTRODICASA-CONSTRUCCIONES-LOGO.webp' },
    { nombre: 'MATTIEVICH', logo: '/assets/logos/clientes/MATTIEVICH-LOGO.webp' },
    { nombre: 'MERCADO CONCENTRACION FISHERTON', logo: '/assets/logos/clientes/MERCADO-CONCENTRACION-FISHERTON-LOGO.webp' },
    { nombre: 'MILICIC', logo: '/assets/logos/clientes/MILICIC-LOGO.webp' },
    { nombre: 'MOLINOS AGRO', logo: '/assets/logos/clientes/MOLINOS-AGRO-LOGO.webp' },
    { nombre: 'MOLINOS RIO DE LA PLATA', logo: '/assets/logos/clientes/MOLINOS-RIO-DE-LA-PLATA-LOGO.webp' },
    { nombre: 'MONTHELADO', logo: '/assets/logos/clientes/MONTHELADO-LOGO.webp' },
    { nombre: 'MUNDO CONSTRUCCIONES', logo: '/assets/logos/clientes/MUNDO-CONSTRUCCIONES-LOGO.webp' },
    { nombre: 'MUNICIPALIDAD CRESPO', logo: '/assets/logos/clientes/MUNICIPALIDAD-CRESPO-LOGO.webp' },
    { nombre: 'MUNICIPALIDAD DAIREAU', logo: '/assets/logos/clientes/MUNICIPALIDAD-DAIREAU-LOGO.webp' },
    { nombre: 'MUNICIPALIDAD NECOCHEA', logo: '/assets/logos/clientes/MUNICIPALIDAD-NECOCHEA-LOGO.webp' },
    { nombre: 'MUNICIPALIDAD PARANA', logo: '/assets/logos/clientes/MUNICIPALIDAD-PARANA.webp' },
    { nombre: 'MUNICIPALIDAD ROSARIO', logo: '/assets/logos/clientes/MUNICIPALIDAD-ROSARIO-LOGO.webp' },
    { nombre: 'MUNICIPALIDAD SANTO TOME', logo: '/assets/logos/clientes/MUNICIPALIDAD-SANTO-TOME-LOGO.webp' },
    { nombre: 'NOURYON', logo: '/assets/logos/clientes/NOURYON-LOGO.webp' },
    { nombre: 'OLEAGINOSA SAN LORENZO', logo: '/assets/logos/clientes/OLEAGINOSA-SAN-LORENZO-LOGO.webp' },
    { nombre: 'OMEGA CONSTRUCCIONES', logo: '/assets/logos/clientes/OMEGA-CONSTRUCCIONES-LOGO.webp' },
    { nombre: 'OSVALDO METALURGICA', logo: '/assets/logos/clientes/OSVALDO-METALURGICA-LOGO.webp' },
    { nombre: 'PALADINI', logo: '/assets/logos/clientes/PALADINI-LOGO.webp' },
    { nombre: 'PAMPA ENERGIA', logo: '/assets/logos/clientes/PAMPA-ENERGIA-LOGO.webp' },
    { nombre: 'PAPEL TECNICA', logo: '/assets/logos/clientes/PAPEL-TECNICA-LOGO.webp' },
    { nombre: 'PATAGONIA BIOENERGIA', logo: '/assets/logos/clientes/PATAGONIA-BIOENERGIA-LOGO.webp' },
    { nombre: 'PB LEINER', logo: '/assets/logos/clientes/PB-LEINER.webp' },
    { nombre: 'PEITEL', logo: '/assets/logos/clientes/PEITEL-LOGO.webp' },
    { nombre: 'PERFORACIONES BAIGORRIA', logo: '/assets/logos/clientes/PERFORACIONES-BAIGORRIA-LOGO.webp' },
    { nombre: 'PETRO PACK', logo: '/assets/logos/clientes/PETRO-PACK-LOGO.webp' },
    { nombre: 'PETROBRAS', logo: '/assets/logos/clientes/PETROBRAS-LOGO.webp' },
    { nombre: 'PETROQUIMICA RIO TERCERO', logo: '/assets/logos/clientes/PETROQUIMICA-RIO-TERCERO-LOGO.webp' },
    { nombre: 'PROFERTIL', logo: '/assets/logos/clientes/PROFERTIL-LOGO.webp' },
    { nombre: 'PROMAIZ', logo: '/assets/logos/clientes/PROMAIZ-LOGO.webp' },
    { nombre: 'PROTOIL SRL', logo: '/assets/logos/clientes/PROTOIL-SRL.webp' },
    { nombre: 'PUERTO QUEQUEN', logo: '/assets/logos/clientes/PUERTO-QUEQUEN-LOGO.webp' },
    { nombre: 'PURINA', logo: '/assets/logos/clientes/PURINA-LOGO.webp' },
    { nombre: 'QH INGENIERIA', logo: '/assets/logos/clientes/QH-INGENIERIA-LOGO.webp' },
    { nombre: 'RAFAELA', logo: '/assets/logos/clientes/RAFAELA-LOGO.webp' },
    { nombre: 'RENO PACK', logo: '/assets/logos/clientes/RENO-PACK-LOGO.webp' },
    { nombre: 'RENOVA', logo: '/assets/logos/clientes/RENOVA-LOGO.webp' },
    { nombre: 'RICEDAL', logo: '/assets/logos/clientes/RICEDAL-LOGO.webp' },
    { nombre: 'ROVIAL', logo: '/assets/logos/clientes/ROVIAL-LOGO.webp' },
    { nombre: 'SADEPAN LATINOAMERICA', logo: '/assets/logos/clientes/SADEPAN-LATINOAMERICA-LOGO.webp' },
    { nombre: 'SADESA', logo: '/assets/logos/clientes/SADESA-LOGO.webp' },
    { nombre: 'SAJONIA', logo: '/assets/logos/clientes/SAJONIA-LOGO.svg' },
    { nombre: 'SANCHEZ SANCHEZ', logo: '/assets/logos/clientes/SANCHEZ-SANCHEZ-LOGO.webp' },
    { nombre: 'SANCOR', logo: '/assets/logos/clientes/SANCOR-LOGO.webp' },
    { nombre: 'SANIMAT', logo: '/assets/logos/clientes/SANIMAT-LOGO.webp' },
    { nombre: 'SANTA ISABEL', logo: '/assets/logos/clientes/SANTA-ISABEL-LOGO.webp' },
    { nombre: 'SAVENCIA', logo: '/assets/logos/clientes/SAVENCIA-LOGO.webp' },
    { nombre: 'SEMINO', logo: '/assets/logos/clientes/SEMINO-LOGO.webp' },
    { nombre: 'SERVICIOS PORTUARIOS', logo: '/assets/logos/clientes/SERVICIOS-PORTUARIOS-LOGO.webp' },
    { nombre: 'SIEMENS', logo: '/assets/logos/clientes/SIEMENS-LOGO.webp' },
    { nombre: 'SIPAR GERDAU', logo: '/assets/logos/clientes/SIPAR-GERDAU-LOGO.webp' },
    { nombre: 'SOL CONSTRUCCIONES', logo: '/assets/logos/clientes/SOL-CONSTRUCCIONES.webp' },
    { nombre: 'SYNTHON', logo: '/assets/logos/clientes/SYNTHON-LOGO.webp' },
    { nombre: 'TANONI', logo: '/assets/logos/clientes/TANONI-LOGO.webp' },
    { nombre: 'TERMINAL 6', logo: '/assets/logos/clientes/TERMINAL-6-LOGO.webp' },
    { nombre: 'TERMINAL BAHIA BLANCA', logo: '/assets/logos/clientes/TERMINAL-BAHIA-BLANCA-LOGO.webp' },
    { nombre: 'TERMINAL FERTILIZANTES ARGENTINOS', logo: '/assets/logos/clientes/TERMINAL-FERTILIZANTES-ARGENTINOS-LOGO.webp' },
    { nombre: 'TGS', logo: '/assets/logos/clientes/TGS-LOGO.webp' },
    { nombre: 'UNILEVER', logo: '/assets/logos/clientes/UNILEVER-LOGO.webp' },
    { nombre: 'UNIPAR INDUPA', logo: '/assets/logos/clientes/UNIPAR-INDUPA-LOGO.webp' },
    { nombre: 'VALVULAS Y BOMBAS', logo: '/assets/logos/clientes/VALVULAS-Y-BOMBAS-LOGO.webp' },
    { nombre: 'VARTECO', logo: '/assets/logos/clientes/VARTECO-LOGO.webp' },
    { nombre: 'VERONICA', logo: '/assets/logos/clientes/VERONICA-LOGO.webp' },
    { nombre: 'VICENTIN', logo: '/assets/logos/clientes/VICENTIN-LOGO.webp' },
    { nombre: 'VITERRA', logo: '/assets/logos/clientes/VITERRA-LOGO.webp' },
    { nombre: 'WERK', logo: '/assets/logos/clientes/WERK-LOGO.webp' },
    { nombre: 'WINKELMANN', logo: '/assets/logos/clientes/WINKELMANN-LOGO.webp' },
    { nombre: 'YPF', logo: '/assets/logos/clientes/YPF-LOGO.webp' },
  ];

  const beneficios = [
    {
      titulo: 'Experiencia comprobada',
      descripcion: 'Más de 35 años acompañando el desarrollo industrial en Argentina.'
    },
    {
      titulo: 'Marcas líderes',
      descripcion: 'Representamos a KSB y TECNAL, fabricantes de reconocimiento mundial.'
    },
    {
      titulo: 'Soporte especializado',
      descripcion: 'Asesoramiento técnico en todas las etapas del proyecto.'
    },
    {
      titulo: 'Soluciones personalizadas',
      descripcion: 'Adaptamos cada propuesta a las necesidades específicas de cada cliente.'
    },
    {
      titulo: 'Compromiso con la calidad',
      descripcion: 'Equipos confiables que garantizan eficiencia y durabilidad.'
    },
    {
      titulo: 'Servicio post-venta',
      descripcion: 'Acompañamiento continuo para asegurar el óptimo funcionamiento de los equipos.'
    }
  ];

  return (
    <div className="clientes-container">
      {/* Hero Section */}
      <section className="clientes-hero">
        <div className="clientes-hero-content">
          <h1 className="clientes-hero-title">Nuestros Clientes</h1>
          <p className="clientes-hero-subtitle">
            Cada una de estas empresas representa una relación construida sobre confianza, compromiso y resultados.
          </p>
        </div>
      </section>

      {/* Logos de Clientes */}
      <section className="clientes-logos-section">
        <div className="container">
          {SHOW_LOGOS ? (
            <div className="clientes-logos-grid">
              {clientes.map((cliente, idx) => (
                <div key={idx} className="cliente-logo-card">
                  <img src={cliente.logo} alt={cliente.nombre} loading="lazy" className="cliente-logo" />
                </div>
              ))}
            </div>
          ) : (
            <div className="clientes-logos-placeholder">
              <p>Estamos actualizando nuestra lista de clientes. ¡Próximamente!</p>
            </div>
          )}
        </div>
      </section>

      {/* Sectores */}
      <section className="clientes-sectores-section">
        <div className="container">
          <h2 className="section-title">Sectores que Atendemos</h2>
          <p className="section-description">
            Nuestra experiencia abarca una amplia gama de industrias, cada una con necesidades específicas 
            que atendemos con soluciones personalizadas.
          </p>
          
          <div className="clientes-sectores-grid">
            {sectores.map((sector, idx) => (
              <div key={idx} className="clientes-sector-card">
                <div className="clientes-sector-icon">{sector.icon}</div>
                <h3 className="clientes-sector-nombre">{sector.nombre}</h3>
                <p className="clientes-sector-descripcion">{sector.descripcion}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Por qué nos eligen */}
      <section className="clientes-beneficios-section">
        <div className="container">
          <h2 className="section-title">¿Por qué nos eligen?</h2>
          <div className="clientes-beneficios-grid">
            {beneficios.map((beneficio, idx) => (
              <div key={idx} className="clientes-beneficio-item">
                <h3>{beneficio.titulo}</h3>
                <p>{beneficio.descripcion}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="clientes-cta-section">
        <div className="container">
          <h2 className="clientes-cta-title">Representamos tecnología que potencia la eficiencia y confiabilidad de tus procesos</h2>
          <Button 
            size="lg" 
            className="clientes-cta-button"
            onClick={() => window.open(whatsappLink, '_blank')}
          >
            <Phone className="mr-2" size={20} />
            Contactanos
          </Button>
        </div>
      </section>
    </div>
  );
};

export default Clientes;
